import { Box, Button } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { SubmitHandler, set, useForm } from "react-hook-form";
import SignaturePad from "react-signature-canvas";
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { FTextField, FCheckField, FSelectField, FSignPad, FormBuilder } from "../../utils/FormBuilder/FormBuilder";
import { generateValidationSchema } from "../../utils/FormBuilder/Validators";
import { FormField } from "../../interfaces/User.interface";
import { MemberCreateStage1Data } from "../../interfaces/User.interface";
import { PhoneInputMask } from "../../utils/FormatedInputMask";



const emailField: FormField = {
    name: "email",
    question: "Email",
    validation: "email",
    required: true,
    questionType: "text",
};

const firstNameField: FormField = {
    name: "firstName",
    question: "First Name",
    validation: "text",
    required: true,
    questionType: "text",
};

const lastNameField: FormField = {
    name: "lastName",
    question: "Last Name",
    validation: "text",
    required: true,
    questionType: "text",
};

const phoneField: FormField = {
    name: "phone",
    question: "Phone Number",
    validation: "phone",
    required: true,
    questionType: "text",
    inputProps: {
        inputComponent: PhoneInputMask
    }
};






export const Step1AnswerQuestions: React.FC<{
    handleNext: () => void;
    prevData: MemberCreateStage1Data;
    setStep1Data: (data: any) => void;
}> = ({ handleNext, prevData, setStep1Data }) => {
    const [formFields, setFormFields] = useState<FormField[]>([]);
    const validationSchema = useMemo(() => generateValidationSchema(formFields), [formFields]);
    const {
        handleSubmit,
        control, watch,
        formState: { errors },
        reset
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            ...prevData
        }
    });
    
    useEffect(() => {
        setFormFields([emailField, firstNameField, lastNameField, phoneField]);
    }, []);

    const onSubmit = (data: any) => {
        setStep1Data((prevData: any) => ({ ...prevData, ...data }));
        reset();
        handleNext();
    // Clear the form after submission
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} id="form">
            {
                FormBuilder(formFields, control, errors)
            }
            <Button type="submit" variant="contained" color="primary" form="form">
                Submit
            </Button>
        </form>

    );
};


